<template>
  <v-app>

    <template>
      <v-container>
        <v-flex xs12>
          <v-breadcrumbs
            large
            :items="items"
            divider=">"
          ></v-breadcrumbs>
        </v-flex>
        <v-toolbar
          flat
          color="white"
        >
          <v-toolbar-title>
            <HDDpdfExport
              v-if='currentLotAssets && currentLotAssets.length >0'
              :HDDs="currentLotAssets"
              :LotDetail="currentLot"
            />
            <v-btn
              v-else
              disabled
              color="green darken-1"
              flat
            >Download Wipe Report</v-btn>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>

        <v-data-table
          v-if='currentLot'
          :headers="headers"
          :items="currentLot.Assets"
          :search="search"
          class="elevation-1"
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <td>{{props.item}}</td>
            <td>{{isHDDWIPE(props.item)}}</td>
          </template>
        </v-data-table>
      </v-container>
    </template>

  </v-app>
</template>


<script>
import HDDpdfExport from "../components/HDDpdfExport"
const fb = require("../firebaseConfig.js");
import { mapFields } from "vuex-map-fields";

export default {
  name: "Lots",
  components: {
    HDDpdfExport
  },
  data () {
    return {
      search: '',
      items: [
        {
          text: 'Home',
          disabled: false,
          to: '/home'
        },
        {
          text: 'Lots',
          disabled: false,
          to: '/lots'
        },
        {
          text: this.$route.params.name,
          disabled: true,
        },
      ],
      messages: [],
      name: null,
      currentLot: null,
      currentLotAssets: [],
      deleteDialog: false,
      currentOBJ: null,
      headers: [
        { text: "AssetTag", value: "AssetTag" },
        { text: "HDDs Wiped?", value: "client" },
      ]
    };
  },
  computed: {
    ...mapFields(["snackBarMessage",
      "snackBar", "snackBarcolor", "addLocationdialog"])
  },
  methods: {
    isHDDWIPE (item) {
      if (this.currentLotAssets.find(data => data.AssetTag === item.toString())) {
        return true
      }
      else {
        return "N/A"
      }
    }
  },
  mounted () {
    fb.LotsCollections.where("lotNumber", "==", parseInt(this.$route.params.name)).get().then(datas => {
      datas.forEach(doc => {
        this.currentLot = doc.data()
        this.currentLot.Assets.forEach(assets => {
          fb.HDDWIPECollection.where("AssetTag", "==", assets.toString()).get().then(Adatas => {
            Adatas.forEach(doc => {
              this.currentLotAssets.push(doc.data())
            })
          })
        })
      });
    })
  }
};
</script>


<style>
.iconPic {
  width: 40px;
  margin-left: 1%;
}
</style>